import { observer } from "mobx-react";
import { AuthPageDesktop } from "./Desktop";
import { Header } from "./Header";
import { AuthPageMobile } from "./Mobile";
import classes from "./styles.module.scss";
import { isMobileDevice } from "../../../utils/isMobileDevice";

export default observer(({ children }: { children?: React.ReactNode }) => {
  const isMobile = isMobileDevice();

  return (
    <div className={classes.wrapper}>
      <Header />
      {isMobile ? (
        <AuthPageMobile>{children}</AuthPageMobile>
      ) : (
        <AuthPageDesktop>{children}</AuthPageDesktop>
      )}
    </div>
  );
});
